import { withChartLayout } from 'components/common';
import DeliveryRoomRecord from 'components/features/chart/special-charts/delivery-room-record/DeliveryRoomRecord';

const DeliveryRoomRecordPage = withChartLayout('Delivery Room Record')(DeliveryRoomRecord);
export default DeliveryRoomRecordPage;
